import {
  registerApplication,
  start,
  navigateToUrl,
  getMountedApps,
  getAppStatus,
} from 'single-spa';
import { getApps,setAppsResources } from './src/apps/main';
import { checkPath } from './src/utils/app';
import { parseUri, sleep } from './src/utils/common';
import './src/utils/eventBus';
import 'construct-style-sheets-polyfill';

let apps;

async function init(appJson) {
  // 注册模块
  apps = getApps(appJson);
  for (const k of apps) {
    registerApplication(
      // Name of our single-spa application
      k.id,
      // loadingFunction
      k.loadingFunction,
      // activityFunction
      () => {
        let eventBus = window.TNBL.eventBus
        let isActive = checkPath(k.path)
        if(isActive){
          eventBus.dispatchGlobal("mfe-start",k.path)
        }
        if(window.delayResEnable && window.delayResEnable.isBlockMfeRediret){
          return false
        }
        return isActive
        
      },
    );
  }

  document.addEventListener(
    'click',
    function (e) {
      let { target } = e;
      while (target && target != this) {
        if (target.dataset && target.dataset.event == 'single-spa-snav') {
          // 判断是否需要跳转
          const destPath = target.getAttribute && target.getAttribute('path');
          const destTarget = target.getAttribute && target.getAttribute('target');
          redirectUrl(destPath, destTarget, event);
          // event.preventDefault()
          break;
        }
        target = target.parentNode;
      }
    },
    false,
  );
  window.addEventListener('single-spa:before-routing-event', () => {
    setMenu(parseUri(location.href));
  });

  start();
  if (firstPath) {
    redirectUrl(firstPath);
  }
}

let firstPath;
let firstModule = true;

function redirectUrl(destPath, destTarget, event) {
  if (destTarget === '_blank') {
    window.open(destPath);
    return;
  }
  if (!apps) {
    firstPath = destPath;
    return;
  }

  destTarget = destTarget || '_self';
  const current = parseUri(window.location.href);
  const destination = parseUri(destPath);
  // check status
  const appState = getAppStatus(destination.path);
  const inLoad = [
    'NOT_BOOTSTRAPPED',
    'LOADING_SOURCE_CODE',
    'BOOTSTRAPPING',
    'MOUNTING',
    'MOUNTED',
  ];
  if (appState === 'MOUNTED' && destination.query != current.query) {
    window.location.href = destPath;
    return;
  } if (appState && inLoad.includes(appState)) {
    firstModule = false;
    setMenu(destination);
    return;
  }

  if (firstModule) {
    firstModule = false;
    // 回调
    setMenu(destination);
    if (current.path === '/') {
      navigateToUrl(destPath);
    }
    return;
  }

  let singlePage = false;
  if (current.path === '/') {
    singlePage = true;
  } else if (current.host !== destination.host && destination.host) {
    singlePage = false;
  } else {
    const curApps = getMountedApps();
    let curApp; let nextApp;
    for (const k of apps) {
      if (curApps.includes(k.id)) {
        curApp = k;
      }
      if (destination.path.indexOf(k.path) == 0) {
        nextApp = k;
      }
    }
    if (curApp && nextApp && curApp.type > 1 && nextApp.type > 1) {
      singlePage = true;
    }
  }
  if (destTarget == '_self') {
    if (singlePage) {
      // 回调
      setMenu(destination);
      navigateToUrl(destPath);
      event && event.preventDefault();
    } else {
      window.location.href = destPath;
    }
  } else {
    window.open(destPath);
  }
}

function setMenu(destination) {
  if (
    window.__ResetCurMenu
    && typeof window.__ResetCurMenu === 'function'
  ) {
    let menuPath = destination.path;
    if (!destination.query && destination.anchor) {
      menuPath += `#${parseUri(destination.anchor).path}`;
    }
    window.__ResetCurMenu(menuPath);
  }
}



let timmer_checkApps
function microfrontend() {
  const TNBL = window.TNBL || (window.TNBL = {});
  TNBL.redirectUrl = redirectUrl;
  let urls;
  const arrPros = [];
  urls = getAppsUrl()
  for (const url of urls) {
    url += `rnd=${Math.random()}`;
    arrPros.push(
    fetch(url).then((r)=>{
      return r.json()
    }).catch((ex)=>{
      return {
        err:ex,
        url:url
      }
    }));
  }
  Promise.all(arrPros).then(async (modules) => {
    const allApps = {};
    for (const m of modules) {
      if(m && !m.err){
        Object.assign(allApps, m);
      }
      if(m && m.err){
        console.log('fetch apps error:'+m.url)
        console.log(m.err)
      }
    }
    let waitSec = 35;
    while (!window.__isPadPage && waitSec > 0) {
      if (window.__GetFrameDataByKey) {
        const menu = window.__GetFrameDataByKey('menu');
        if (menu && menu[3]) {
          break;
        }
      } else if (waitSec < 30) {
        break;
      }
      await sleep(1000);
      waitSec = waitSec - 1;
    }
    setAppsResources(allApps)
    init(allApps);
    
    document.addEventListener('visibilitychange', ()=>{
      clearCheckApps()
      if (!document.hidden) {
        checkApps()
      }
    });
    setTimeoutCheckApps()
  }).catch((ex)=>{
    console.log('process apps error')
    console.log(ex)
  });
}
function getScriptAppsUrl(){
  const appsScripts = document.querySelectorAll('script[type=\'systemjs-importmap\']');
  const urls = [];
  for (const script of appsScripts) {
    let { src } = script;
    if (src && src.indexOf('importmap') > 0) {
      src = src.replace('importmap', 'apps');
      urls.push(src);
    }
  }
  return urls
}

function getAppsUrl(){
  const appsUrls = window.importmapJsonPath || getScriptAppsUrl();
  const urls = [];
  for (let src of appsUrls) {
    if (src.indexOf('?') > 0) {
      src += '&';
    } else {
      src += '?';
    }
    src += `rnd=`;
    urls.push(src);
  }
  return urls
}



let appCachKeys = {
}

async function checkApps(){
  const urls = getAppsUrl()
  let arrPros=[]
  let dtHours = new Date().getHours()
  if(dtHours>=8 && dtHours<=20){
    for (const url of urls) {
      arrPros.push(
        fetch(url).then((r)=>{
          let lastModifyed = r.headers.get('last-modified')
          if(appCachKeys[url] && appCachKeys[url]['last-modified']=== lastModifyed){
            return {
              code:304,
            }
          }
          if(lastModifyed){
            let appCach = appCachKeys[url] || (appCachKeys[url]={})
            appCach['last-modified'] = lastModifyed
          }
          return r.json()
        })
        );
    }
  }
  Promise.all(arrPros).then(async (modules) => {
    const allapps = {};
    for (const m of modules) {
      if(!(m.code && m.code ===304)){
        Object.assign(allapps, m);
      }
    }
    //设置apps资源，并返回新的apps
    let newApps = setAppsResources(allapps)
    if(Object.keys(newApps).length>0){
      // 注册模块
      let napps = getApps(newApps,true);
      for (const k of napps) {
        registerApplication(
          // Name of our single-spa application
          k.id,
          // loadingFunction
          k.loadingFunction,
          // activityFunction
          () => {
            let eventBus = window.TNBL.eventBus
            let isActive = checkPath(k.path)
            if(isActive){
              eventBus.dispatchGlobal("mfe-start",k.path)
            }
            return isActive
            
          },
        );
      }
      if(apps && (apps instanceof Array)){
        apps = apps.concat(napps)
      }
    }
    setTimeoutCheckApps()
  }).catch((err)=>{
    console.log(err)
    setTimeoutCheckApps()
  })
}
function clearCheckApps(){
  if(timmer_checkApps){
    clearTimeout(timmer_checkApps);
    timmer_checkApps = null
  }
}
function setTimeoutCheckApps(){
  clearCheckApps()
  if (!document.hidden) {
    timmer_checkApps = setTimeout(checkApps,90*1000)
  }
}



microfrontend();
